// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-author-name-text {
  white-space: nowrap;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.card-author-info {
  gap: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/SmartFeed/scripts/components/publication/layouts/PublicationCollaboratorCardSmall.vue","webpack://./PublicationCollaboratorCardSmall.vue"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;ACDF;ADIA;EACE,mBAAA;ACDF","sourcesContent":["@import \"@/styles/breakpoint-mixin.scss\";\n\n.card-author-name-text {\n  white-space: nowrap;\n  max-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.card-author-info {\n  gap: 0px !important;\n}\n",".card-author-name-text {\n  white-space: nowrap;\n  max-width: 100px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.card-author-info {\n  gap: 0px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
